import React, { useMemo } from "react";
import objectPath from "object-path";
import { Outlet, useLocation } from "react-router-dom";

// import {StickyToolbar} from "./extras/StickyToolbar";
// import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";

import { Aside } from "./aside/Aside";
// import {QuickPanel} from "./extras/offcanvas/QuickPanel";
// importt {QuickUser} from "./extras/offcanvas/QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
// Import Layout components
// import {Header} from "./header/Header";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { SubHeader } from "./subheader/SubHeader";
// import {Footer} from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
// import { ReactQueryDevtools } from 'react-query/devtools'

const Layout = ({ children }) => {
  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const location = useLocation();

  const elem = document.getElementById('main-archem-app');
  elem.classList.remove('main-archem-app');
  // const locsPadding = [
  //   { path: '/payroll', paddingTop: '0px', paddingLeft: '0px', paddingRight: '0px', ktContentCssClass: 'p-0' },
  //   { path: '/payroll/attendance/workschedules', paddingTop: 0, paddingLeft: 0, paddingRight: 14, ktContentCssClass: 'p-0' },
  //   { path: '/payroll/requests', paddingTop: '0px', paddingLeft: '0px', paddingRight: '0px' },
  //   { path: '/payroll/timesheets', paddingTop: '0px', paddingLeft: '0px', paddingRight: '0px', ktContentCssClass: 'p-0' },
  //   { path: '/logistics', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/tanksounding', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/dashboard', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/movements', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/purchasing', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/rawmats', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/salescontract', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/nonrawmats', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/ucap', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/cnopricemonitor', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/dayentry', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/pms', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/report', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/maintenance', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/calendardashboard', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/exportmonitoring', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/importmonitoring', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/tradesummary', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  //   { path: '/settings', paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' },
  // ];


  // const padToUse = locsPadding.find(l => location.pathname.startsWith(l.path));
  // const padToUse = { paddingTop: '10px', paddingLeft: '10px', paddingRight: '10px', ktContentCssClass: 'p-0' }
  // const contentPadding = {
  //     paddingTop: padToUse ? padToUse.paddingTop : '25px',
  //     paddingLeft: padToUse ? padToUse.paddingLeft : '25px',
  //     paddingRight: padToUse ? padToUse.paddingRight : '25px'
  // };


  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended")
    };
  }, [uiService]);

  // const queryClient = new QueryClient({
  //   defaultOptions: {
  //     queries: {
  //       refetchOnWindowFocus: false,
  //       retry: false,
  //       cacheTime: 0 
  //     }
  //   },
  //   queryCache: new QueryCache({
  //     onError: (error) =>
  //       console.log(error), 
  //   }),
  // })

  return layoutProps.selfLayout !== "blank" ? (
    <>
      <HeaderMobile />
      <div className="d-flex flex-column flex-root">

        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && (<Aside />)}
          <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">

            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid ${location.pathname === '/payroll/attendance/workschedules' ? 'pb-0' : ''} `}
            >
              {layoutProps.subheaderDisplay && <SubHeader />}
              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses} >
                    {/* {children} */}
                    <Outlet />
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
            </div>
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}


      </div>
      {/* <QuickUser/>
            <QuickPanel/> */}
      <ScrollTop />
      {/* <StickyToolbar/> */}
      {/*end::Main*/}
      <LayoutInit />
      {/* <ReactQueryDevtools  /> */}
      {/* </QueryClientProvider> */}
    </>
  ) : (
    // BLANK LAYOUT
    (<div className="d-flex flex-column flex-root">{children}</div>)
  );
}

export default Layout;